/**
 * @desc 查询发货信息
 */
const URL = "/rantion-oms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.oms.systemOrderPackageDeliveryInformation.getDeliveryInformation.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/systemOrderPackageDeliveryInformation/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
